module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAUCAMAAAC3SZ14AAAAb1BMVEUAAACqqqqqqqqwsLCqqqqrq6urq6uurq6qqqqrq6uqqqqsrKytra28vLyqqqqqqqqqqqqqqqqqqqqrq6urq6urq6uurq6qqqqqqqqrq6uwsLCqqqqqqqqqqqqqqqqrq6usrKypqampqampqampqanYjIypAAAAJXRSTlMAqWYKoJZEELSDei8iBL+3rZxwTko5FHxgQB3PxqKLVRrfpFxWAkk6JwAAALhJREFUGNNVzVcSgzAMBFCtXDG9hZICKfc/YyC2YbI/0jzZEv0iXAWgpTNZOe3e1HmUubz4Rktvl9GucdhVkyCy6uNHft7cF5I9/eXRkx7DUeMrtqc1kQZwrwEMlGNjORNMNr25S40UvGy0WqHrhFs9Dsr1Fe1JbbyQM4TvzLWw2FLcFMVAcamb6sHJSaD2eZ07llGMKl+JyCAdIqXulu21VQcdH3AQx7VQJlDCHMilgZoidEOx7/wCM6kHruoxkVUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/productos.png
// module id = 528
// module chunks = 0